Apt.fn.make('blogs', {
	/**
	 * Initialize module
	 */
	init() {
		const $search = $$('blogSearch');

		$search.on('submit', () => {
			$.history.go('/blog/filter/keywords=' + encodeURIComponent(
				$.first('input', $search).value
			));
		}, {
			cancel: true,
			namespace: 'blog'
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		$.events.reset('blog');
	}
});